"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelingTaskStatus = void 0;
var LabelingTaskStatus;
(function (LabelingTaskStatus) {
    LabelingTaskStatus["Success"] = "SUCCESS";
    LabelingTaskStatus["Failure"] = "FAILURE";
    LabelingTaskStatus["Pending"] = "PENDING";
})(LabelingTaskStatus = exports.LabelingTaskStatus || (exports.LabelingTaskStatus = {}));
//# sourceMappingURL=LabelingTask.js.map